import { render, staticRenderFns } from "./side-nav.vue?vue&type=template&id=686e87a6"
import script from "./side-nav.vue?vue&type=script&lang=js"
export * from "./side-nav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports